<template>
    <div class="menus floating-home-menu aurora-page aurora-home">
        <div class="menus_box" :class="classObj">
            <div v-for="(item, index) in list" class="menu_info" :key="item.eventType + ':' + (item.id || index)" :data-event-type="item.eventType" :data-event-id="item.id" :title="item.eventType === 'customerServiceTelegram' ? $t('person.LiveChat') : item.eventName" @click="toItem(item)">
                <div class="img_box" :class="{'w81P': item.eventType == 'customerServiceTelegram', 'w85P': item.eventType == 'pinduoduo'}">
                    <AuroraEventIcon v-if="item.eventType === 'customerServiceTelegram'" event-type="customerServiceTelegram" />
                    <img v-else class="floating-api-image" :src="item.homeImgUrl" :alt="item.eventName || ''">
                </div>
                <button v-if="item.eventType !== 'customerServiceTelegram'" type="button" class="floating-close" :aria-label="$t('lang.cancel')" @click.stop="closeItem(index)"><AuroraIcon name="close" /></button>
                <div class="matterNumber" v-if="item.eventType === 'customerPending' && matterNumber">
                    {{ matterNumber }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import AuroraIcon from '@/components/auroraIcon'
import AuroraEventIcon from '@/components/auroraIcon/eventIcon.vue'
import { getCustomEventInfo } from '@/api/event'
import { getEventsHomeShow } from '@/api/home'
import { getHomeActivities } from '@/utils/homeActivities'
export default {
    components: { AuroraIcon, AuroraEventIcon },
    data() {
        return {
            show: true,
            list: [{ eventType: 'customerServiceTelegram' }],
            RedPacketList: []
        }
    },
    computed: {
        isLogin() {
            return !!this.$store.getters.token
        },
        matterNumber() {
            return this.$store.getters.matterNumber
        },
        ...mapState({
            device: state => state.app.device,
            isShowNotification: state => state.app.isShowNotification
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile',
                openNotification: this.isShowNotification
            }
        },
        sysConfig() {
            return this.$store.getters.sysConfig
        }
    },
    mounted() {
        this.getInfo()
    },
    methods: {
        closeItem(index) {
            if (this.list[index] && this.list[index].eventType === 'customerServiceTelegram') return
            this.list.splice(index, 1)
        },
        getPopupContainer() {
            return document.querySelector('.main-container')
        },
        getInfo() {
            return getEventsHomeShow().then(res => {
                if (!res || res.code) return
                this.list = [...getHomeActivities(res.result), { eventType: 'customerServiceTelegram' }]
            })
        },
        toItem(item) {
            // console.log(item)
            if (item.eventType === 'reliefMoney') {
                // this.$store.dispatch('user/setIsShowLossSupportPopup', { id: item.id, show: true })
                this.onNavTo({ url: 'WeeklyRescue', params: { id: item.id } })
            }
            if (item.eventType === 'signIn') {
                this.$store.dispatch('user/setIsShowCheckInPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'vipSignIn') {
                this.onNavToByIsLogin({ url: 'SignIn', params: { id: item.id } })
            }
            if (item.eventType === 'VIP') {
                this.onNavToByIsLogin({ url: 'vip' })
            }
            if (item.eventType === 'luckyWheel') {
                if (this.BelongNation === 'Mexico') {
                    this.$store.dispatch('user/setIsShowTurntable2Popup', { id: item.id, show: true })
                } else {
                    this.$store.dispatch('user/setIsShowTurntablePopup', { id: item.id, show: true })
                }
            }
            if (item.eventType === 'custom') {
                getCustomEventInfo({ id: item.id }).then((res) => {
                    if (res.code) return
                    const D = res.result
                    if (D.displayMode === 'BuiltInPage') {
                        const obj = { id: D.id, eventName: D.eventName, createTime: D.createTime, eventContent: D.eventContent }
                        const params = encodeURIComponent(JSON.stringify(obj))
                        const timestamp = new Date().getTime()
                        this.onNavTo({ url: 'PromotionCustom', type: 'post', params: { timestamp, params } })
                    }
                    if (D.displayMode === 'JumpOutside') {
                        console.log(D.appSkipMode)
                        if (D.appSkipMode === 'newWindowOpen') {
                            const url = D.appHref
                            const type = 'href'
                            this.onNavTo({ url, type })
                        }
                        if (D.appSkipMode === 'nowPageOpen') {
                            // const encodedUrl = encodeURIComponent(D.appHref)
                            // const finalUrl = '/pages/webview/deposit_wv?url=' + encodedUrl
                            // this.onNavTo(finalUrl)
                        }
                        if (D.appSkipMode === 'builtInPageOpen') {
                            const url = D.appHref
                            this.onNavToByIsLogin({ url })
                        }
                    }
                })
            }
            if (item.eventType === 'redPacket') {
                this.$store.dispatch('user/setIsShowRedPacketPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'extend') {
                this.onNavToByIsLogin({}).then(() => {
                    this.$store.dispatch('user/setIsShowTreasureChestPopup', { id: item.id, show: true })
                })
            }
            if (item.eventType === 'gameBetting') {
                this.$store.dispatch('user/setIsShowRebatePopup', { id: item.id, show: true })
            }
            if (item.eventType === 'rechargeRewards') {
                this.onNavTo({ url: '/Affiliate' })
            }
            if (item.eventType === 'gameBettingRewards') {
                this.onNavTo({ url: '/Affiliate' })
            }
            if (item.eventType === 'pinduoduo') {
                this.onNavToByIsLogin({ url: 'Pinduoduo', params: { id: item.id } })
            }
            if (item.eventType === 'rankingList') {
                this.$store.dispatch('user/setIsShowWinRankListPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'registerRewards') {
                const obj = { type: item.eventType }
                const params = encodeURIComponent(JSON.stringify(obj))
                const timestamp = new Date().getTime()
                this.onNavTo({ url: 'PromotionCustom', type: 'post', params: { timestamp, params } })
            }
            if (item.eventType === 'customerServiceTelegram') {
                this.onNavTo({ url: '/notification', type: 'get', params: { type: 0 } })
            }
            if (item.eventType === 'customerPending') {
                this.$store.dispatch('user/setIsShowPendingPopup', true)
            }
            if (item.eventType === 'totalRecharge') {
                this.$store.dispatch('user/setIsShowDepositTotalPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'rechargeGift') {
                this.$store.dispatch('user/setIsShowDepositRepeatPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'usdtRechargeGift') {
                this.$store.dispatch('user/setIsShowDepositRepeatUsdtPopup', { id: item.id, show: true })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.menus {
    position: fixed;
    z-index: 3;
    bottom: 1.8rem;
    right: 0.3rem;
    overflow-y: scroll;

    &.openNotification {
        right: 360px !important;
    }

    &.mobile {
        top: 22%;
        right: 0.3rem;
        bottom: auto;
    }
}

.menu_info {
    position: relative;
    width: 1.4rem;
    height: 1.4rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .img_box {
        width: 100%;
        height: 100%;
        cursor: pointer;
        position: relative;

        &.w81P{
            width: 81%;
            height: 81%;
        }

        &.w85P{
            width: 85%;
            height: 85%;
        }

        >img {
            width: 100%;
            height: 100%;

            &.txt {
                position: absolute;
                height: auto;
                left: 50%;
                transform: translateX(-50%);
                bottom: 0;
                object-fit: contain;
            }
        }
    }

    .iconfont {
        font-size: .22rem;
        position: absolute;
        right: 0;
        top: 0;
        color: var(--aurora-ink);
        cursor: pointer;
        font-weight: bold;
    }

    .matterNumber {
        width: .3rem;
        height: .3rem;
        position: absolute;
        background: red;
        color: var(--aurora-ink);
        display: flex;
        align-items: center;
        justify-content: center;
        top: 0;
        left: 0;
        font-size: .22rem;
        border-radius: 50%;
    }
}

.menus_box {
    display: flex;
    flex-direction: column;
    row-gap: 0.2rem;
    background: transparent;

    &.mobile {
        // row-gap: 0.3rem;

        .menu_info {
            width: 1.2rem;
            height: 1.2rem;

            .title {
                display: none;
            }
        }
    }
}
</style>
